import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Alert } from "reactstrap";

import {
	resetGetViewConfigurationList,
	getViewCongigurationListReq
} from "../../redux/actions/getViewCongigurationListAction";

import {
	resetGetUpdateConfigurationList,
	getUpdateConfigurationList
} from "../../redux/actions/getUpdateConfigurationAction";

import Layout from "../../components/Wrappers/Layout";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextareaAutosize,
	Box
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import BackButton from "../../components/BackButton/BackButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AddNewConfigration = () => {
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	var authToken = regenerateTokenRes.data.AuthToken;

	const location = useLocation();
	const dispatch = useDispatch();
	// const role = location.search.split("?userId=")[1];
	const [getConfigViewStatus, setGetConfigViewStatus] = useState(false);
	const [getConfigViewRes, setGetConfigViewRes] = useState("");

	// Market Place
	const [role, setRole] = useState("");
	const [walletRole, setWalletRole] = useState(role);
	const [dealRequired, setDealRequired] = useState("Y");
	const [orderMgtAllowed, setOrderMgtAllowed] = useState("Y");
	const [prdMgtAllowed, setPrdMgtAllowed] = useState("Y");
	const [orderSellReportAllowed, setorderSellReportAllowed] = useState("Y");
	const [isPromoCodeAllowed, setIsPromoCodeAllowed] = useState("Y");

	//Sign Up and Login
	const [merchantRequired, setMerchantRequired] = useState("Y");
	const [newDeviceCheckAllowed, setNewDeviceCheckAllowed] = useState("Y");
	const [changePasswordAllowed, setchangePasswordAllowed] = useState("Y");
	const [dealerMappingRequired, setDealerMappingRequired] = useState("Y");

	const [prefixAccountId, setPrefixAccountId] = useState("Y");
	const [customerCreationAllowed, setCustomerCreationAllowed] = useState("Y");
	const [emailAllowed, setEmailAllowed] = useState("1");
	const [smsAllowed, setSmsAllowed] = useState("1");

	const [businessSignupAllowed, setBusinessSignupAllowed] = useState("1");
	const [maxUboCount, setmaxUboCount] = useState("0");
	const [maxDirectorCount, setmaxDirectorCount] = useState("1");
	const [autoFilledAllowed, setautoFilledAllowed] = useState("0");

	const [addBankDuringSignUp, setaddBankDuringSignUp] = useState("Y");
	const [dateOfBirthRequired, setdateOfBirthRequired] = useState("1");
	const [nationalityRequired, setnationalityRequired] = useState("Y");
	const [isCustCreationAllowed, setisCustCreationAllowed] = useState('Y');
	const [transactionHistAllowed, settransactionHistAllowed] = useState('Y');
	const [dobRequired, setdobRequired] = useState('Y')

	// Prepaid Card

	const [customerActivateCardRequired, setCustomerActivateCardRequired] =
		useState("Y");
	const [prepaidCardFeatureRequired, setprepaidCardFeatureRequired] =
		useState("Y");
	const [applyingPrepaidCardDuringSignUp, setapplyingPrepaidCardDuringSignUp] =
		useState("Y");

	// Wallet Settings
	const [isSEPAAllowed, setisSEPAAllowed] = useState('N');
	const [myIbanAllowed, setmyIbanAllowed] = useState('N');
	const [loadMoneyAllowed, setLoadMoneyAllowed] = useState("Y");
	const [withdrawMoneyAllowed, setWithdrawMoneyAllowed] = useState("Y");
	const [sendMoneyAllowed, setsendMoneyAllowed] = useState("Y");
	const [requestMoneyAllowed, setRequestMoneyAllowed] = useState("Y");

	const [activityLogAllowed, setactivityLogAllowed] = useState("Y");
	const [walletAllowed, setWalletAllowed] = useState("Y");
	const [payAllowed, setpayAllowed] = useState("Y");
	const [payOption, setpayOption] = useState("");

	const [walletTransferAllowed, setwalletTransferAllowed] = useState("Y");
	const [cashoutAllowed, setcashoutAllowed] = useState("Y");
	const [checkDepositAllowed, setcheckDepositAllowed] = useState("Y");
	const [payOrderAllowed, setPayOrderAllowed] = useState("Y");

	const [payReceivedAllowed, setpayReceivedAllowed] = useState("Y");
	const [cashInAllowed, setcashInAllowed] = useState("Y");
	const [requestCashInAllowed, setrequestCashInAllowed] = useState("Y");
	const [requestCashOutAllowed, setrequestCashOutAllowed] = useState("Y");

	const [withdrawVerificationAllowed, setwithdrawVerificationAllowed] =
		useState("Y");
	const [sendMoneyMerchantRequired, setsendMoneyMerchantRequired] =
		useState("Y");
	const [radioAllowed, setradioAllowed] = useState("Y");
	const [blockChainAllowed, setblockChainAllowed] = useState("Y");
	const [rechargeAllowed, setrechargeAllowed] = useState("Y");

	const [myCardAllowed, setyCardAllowed] = useState("Y");
	const [myBankAllowed, setmyBankAllowed] = useState("Y");
	const [loyaltyPointsAllowed, setloyaltyPointsAllowed] = useState("Y");
	const [transactionHistoryAllowed, settransactionHistoryAllowed] =
		useState("Y");

	const [walletHistoryAllowed, setwalletHistoryAllowed] = useState("Y");
	const [profileSettingsAllowed, setprofileSettingsAllowed] = useState("");
	const [billPaymentAllowed, setbillPaymentAllowed] = useState("Y");
	const [donationAllowed, setdonationAllowed] = useState("Y");
	const [loadwithWalletAllowed, setloadwithWalletAllowed] = useState("Y");
	const [integration, setintegration] = useState("api");
	const [sendSecurityAllowed, setendSecurityAllowed] = useState("Y");
	const [loadSecurityAllowed, setloadSecurityAllowed] = useState("Y");
	const [requestSecurityAllowed, setrequestSecurityAllowed] = useState("Y");
	const [withdrawSecurityAllowed, setwithdrawSecurityAllowed] = useState("Y");
	const [paySecurityAllowed, setpaySecurityAllowed] = useState("Y");
	const [cashoutSecurityAllowed, setcashoutSecurityAllowed] = useState("Y");
	const [payOrderSecurityAllowed, setpayOrderSecurityAllowed] = useState("Y");
	const [purchaseSecurityAllowed, setpurchaseSecurityAllowed] = useState("Y");
	const [cashinSecurityAllowed, setcashinSecurityAllowed] = useState("Y");
	const [userManagement, setuserManagement] = useState("Y");
	const [storeRequired, setstoreRequired] = useState("Y");

	const [voucherPurchaseAllowed, setvoucherPurchaseAllowed] = useState("Y");

	const [transactionHistoryAllowedv, settransactionHistoryAllowedv] =
		useState("Y");
	const [myVoucherAllowed, setmyVoucherAllowed] = useState("Y");
	const [redeemPasswordAllowed, setredeemPasswordAllowed] = useState("Y");

	const [redeemAuthentication, setredeemAuthentication] = useState("");
	const [redeemExactOrderAmount, setredeemExactOrderAmount] = useState("Y");
	const [settlementReportRequired, setsettlementReportRequired] = useState("Y");
	const [aPIKeyRequired, setaPIKeyRequired] = useState("Y");
	const [notificationOpen, setNotificationOpen] = useState(false);

	const [updateConfigurationStatus, setUpdateConfigurationStatus] =
		useState(false);
	const [updateConfigurationArray, setUpdateConfigurationArray] = useState("");

	const [sendToContactAllowed, setsendToContactAllowed] = useState('Y');
	const [sendToSelfAllowed, setsendToSelfAllowed] = useState('Y');
	const [sendToOtherAllowed, setsendToOtherAllowed] = useState('Y');
	const [checkBalanceAllowed, setcheckBalanceAllowed] = useState('Y');
	const [manageBeneficiariesAllowed, setmanageBeneficiariesAllowed] = useState('Y');
	const [profSettAlloweds, setprofSettAlloweds] = useState('Y');
	//Refund configuration
	const [getRefund, setGetRefund] = useState('Y');
	const [getFullRefund, setGetFullRefund] = useState('Y');
	const [getPartialRefund, setGetPartialRefund] = useState('Y');
	const [settlement, setSettlement]= useState('Y');
	const [refundmodule,setRefundmodule]=useState('Y');
	const [summaryreportmodule , setSummaryReportModule] = useState('Y')
	

	//Checkout configuration
	const [getIsTermsAndConditions, setGetIsTermsAndConditions] = useState('Y');
	// const [getTermsURL, setGetTermsURL] = useState("");
	const [getRedirectTime, setGetRedirectTime] = useState("");
	const [getIsAutoRedirect, setGetIsAutoRedirect] = useState('Y');
	const [countrySelection, setcountrySelection] = useState('N');
	const [studentId, setStudentId] = useState('N');
	const [studentName, setStudentName] = useState('N');
	const [studentCountry, setStudentCountry] = useState('N');


	//Two Factor Authentucation

	const [twofaSmsOtpAllowed, settwofaSmsOtpAllowed] = useState('N');
	const [twofaEmailOtpAllowed, settwofaEmailOtpAllowed] = useState('N');
	const [twofaConfigurationUser, settwofaConfigurationUser] = useState('N');
	const [twofaconfigurationGoogle, settwofaconfigurationGoogle] = useState('N'); //change made rohit 18/6/2025

	//Consent (Transaction and Sign Up)
	const [getSignUpConsent, setGetSignUpConsent] = useState('N');
	const [getTransactionConsent, setGetTransactionConsent] = useState('N');
	const [getKycRequired, setGetKycRequired] = useState('N')


	const getWalletRolesRes = useSelector(
		({ walletAcRequired }) => walletAcRequired
	);

	const getViewCongigurationListRes = useSelector(
		({ getViewCongigurationList }) => getViewCongigurationList
	);

	const updateConfigurationListRes = useSelector(
		({ getUpdateConfiguration }) => getUpdateConfiguration
	);

	useEffect(() => {
		dispatch(resetGetUpdateConfigurationList());
	}, []);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "role") {
			setRole(value);
		}

		if (name === "walletRole") {
			setWalletRole(value);
		}

		if (name === "dealRequired") {
			setDealRequired(value);
		}
		if (name === "orderMgtAllowed") {
			setOrderMgtAllowed(value);
		}
		if (name === "prdMgtAllowed") {
			setPrdMgtAllowed(value);
		}

		if (name === "orderSellReportAllowed") {
			setorderSellReportAllowed(value);
		}

		if (name === "isPromoCodeAllowed") {
			setIsPromoCodeAllowed(value);
		}

		//Sign Up and Login Start

		if (name === "merchantRequired") {
			setMerchantRequired(value);
		}

		if (name === "newDeviceCheckAllowed") {
			setNewDeviceCheckAllowed(value);
		}

		if (name === "changePasswordAllowed") {
			setchangePasswordAllowed(value);
		}

		if (name === "dealerMappingRequired") {
			setDealerMappingRequired(value);
		}

		if (name === "prefixAccountId") {
			const isAlpha = /^[a-zA-Z]*$/.test(value);
			if (value.length <= 4 && isAlpha) {
				setPrefixAccountId(value);
			}
		}

		if (name === "customerCreationAllowed") {
			setCustomerCreationAllowed(value);
		}

		if (name === "emailAllowed") {
			setEmailAllowed(value);
		}

		if (name === "smsAllowed") {
			setSmsAllowed(value);
		}

		if (name === "businessSignupAllowed") {
			setBusinessSignupAllowed(value);
		}

		if (name === "maxUboCount") {
			setmaxUboCount(value);
		}

		if (name === "maxDirectorCount") {
			setmaxDirectorCount(value);
		}

		if (name === "autoFilledAllowed") {
			setautoFilledAllowed(value);
		}

		if (name === "addBankDuringSignUp") {
			setaddBankDuringSignUp(value);
		}

		if (name === "dateOfBirthRequired") {
			setdateOfBirthRequired(value);
		}

		if (name === "nationalityRequired") {
			setnationalityRequired(value);
		}

		if (name === 'isCustCreationAllowed') {
			setisCustCreationAllowed(value)
		}

		if (name === 'transactionHistAllowed') {
			settransactionHistAllowed(value);
		}

		if (name === 'ifDOBrequired') {
			setdobRequired(value);
		}

		//Prepaid Card

		if (name === "customerActivateCardRequired") {
			setCustomerActivateCardRequired(value);
		}

		if (name === "prepaidCardFeatureRequired") {
			setprepaidCardFeatureRequired(value);
		}

		if (name === "applyingPrepaidCardDuringSignUp") {
			setapplyingPrepaidCardDuringSignUp(value);
		}

		//Wallet Settings

		if (name === 'isSEPAAllowed') {
			setisSEPAAllowed(value);
		}

		if (name === 'myIbanAllowed') {
			setmyIbanAllowed(value);
		}

		if (name === "loadMoneyAllowed") {
			setLoadMoneyAllowed(value);
		}

		if (name === "withdrawMoneyAllowed") {
			setWithdrawMoneyAllowed(value);
		}

		if (name === "sendMoneyAllowed") {
			setsendMoneyAllowed(value);
		}

		if (name === "requestMoneyAllowed") {
			setRequestMoneyAllowed(value);
		}

		if (name === "activityLogAllowed") {
			setactivityLogAllowed(value);
		}

		if (name === "walletAllowed") {
			setWalletAllowed(value);
		}

		if (name === "payAllowed") {
			setpayAllowed(value);
		}

		if (name === "payOption") {
			setpayOption(value == "Select Pay Option" ? "" : value);
		}

		if (name === "walletTransferAllowed") {
			setwalletTransferAllowed(value);
		}

		if (name === "cashoutAllowed") {
			setcashoutAllowed(value);
		}

		if (name === "checkDepositAllowed") {
			setcheckDepositAllowed(value);
		}

		if (name === "payOrderAllowed") {
			setPayOrderAllowed(value);
		}

		if (name === "payReceivedAllowed") {
			setpayReceivedAllowed(value);
		}

		if (name === "cashInAllowed") {
			setcashInAllowed(value);
		}

		if (name === "requestCashInAllowed") {
			setrequestCashInAllowed(value);
		}

		if (name === "requestCashOutAllowed") {
			setrequestCashOutAllowed(value);
		}

		if (name === "withdrawVerificationAllowed") {
			setwithdrawVerificationAllowed(value);
		}

		if (name === "sendMoneyMerchantRequired") {
			setsendMoneyMerchantRequired(value);
		}

		if (name === "radioAllowed") {
			setradioAllowed(value);
		}

		if (name === "blockChainAllowed") {
			setblockChainAllowed(value);
		}
		if (name === "rechargeAllowed") {
			setrechargeAllowed(value);
		}

		if (name === "myCardAllowed") {
			setyCardAllowed(value);
		}

		if (name === "myBankAllowed") {
			setmyBankAllowed(value);
		}

		if (name === "loyaltyPointsAllowed") {
			setloyaltyPointsAllowed(value);
		}

		if (name === "transactionHistoryAllowed") {
			settransactionHistoryAllowed(value);
		}

		if (name === "walletHistoryAllowed") {
			setwalletHistoryAllowed(value);
		}

		if (name === "walletHistoryAllowed") {
			setwalletHistoryAllowed(value);
		}

		if (name === "profileSettingsAllowed") {
			setprofileSettingsAllowed(value);
		}

		if (name === "billPaymentAllowed") {
			setbillPaymentAllowed(value);
		}

		if (name === "donationAllowed") {
			setdonationAllowed(value);
		}

		if (name === "loadwithWalletAllowed") {
			setloadwithWalletAllowed(value);
		}

		if (name === "integration") {
			setintegration(value);
		}

		if (name === "sendSecurityAllowed") {
			setendSecurityAllowed(value);
		}

		if (name === "loadSecurityAllowed") {
			setloadSecurityAllowed(value);
		}

		if (name === "requestSecurityAllowed") {
			setrequestSecurityAllowed(value);
		}

		if (name === "withdrawSecurityAllowed") {
			setwithdrawSecurityAllowed(value);
		}

		if (name === "paySecurityAllowed") {
			setpaySecurityAllowed(value);
		}

		if (name === "cashoutSecurityAllowed") {
			setcashoutSecurityAllowed(value);
		}

		if (name === "payOrderSecurityAllowed") {
			setpayOrderSecurityAllowed(value);
		}

		if (name === "purchaseSecurityAllowed") {
			setpurchaseSecurityAllowed(value);
		}

		if (name === "cashinSecurityAllowed") {
			setcashinSecurityAllowed(value);
		}

		if (name === "userManagement") {
			setuserManagement(value);
		}

		if (name === "storeRequired") {
			setstoreRequired(value);
		}

		if (name === 'profSettAllowed') {
			setprofSettAlloweds(value);
		}

		// Voucher Configuration
		if (name === "voucherPurchaseAllowed") {
			setvoucherPurchaseAllowed(value);
		}

		if (name === "transactionHistoryAllowedv") {
			settransactionHistoryAllowedv(value);
		}

		if (name === "myVoucherAllowed") {
			setmyVoucherAllowed(value);
		}

		if (name === "redeemPasswordAllowed") {
			setredeemPasswordAllowed(value);
		}

		if (name === "redeemAuthentication") {
			setredeemAuthentication(
				value == "Select Redeem Authentication" ? "" : value
			);
		}

		if (name === "redeemExactOrderAmount") {
			setredeemExactOrderAmount(value);
		}
		if (name === "settlementReportRequired") {
			setsettlementReportRequired(value);
		}

		if (name === "aPIKeyRequired") {
			setaPIKeyRequired(value);
		}

		//Bank Configuration
		if (name === 'sendToContactAllowed') {
			setsendToContactAllowed(value);
		}
		if (name === 'sendToSelfAllowed') {
			setsendToSelfAllowed(value);
		}
		if (name === 'sendToOtherAllowed') {
			setsendToOtherAllowed(value);
		}
		if (name === 'checkBalanceAllowed') {
			setcheckBalanceAllowed(value);
		}
		if (name === 'manageBeneficiariesAllowed') {
			setmanageBeneficiariesAllowed(value);
		}

		//Refund configuration 
		if (name === 'getRefund') {
			setGetRefund(value);
		}
		if (name === 'getPartialRefund') {
			setGetPartialRefund(value);
		}
		if (name === 'getFullRefund') {
			setGetFullRefund(value);
		}
		//Checkout configuration 
		if (name === "getIsTermsAndConditions") {
			setGetIsTermsAndConditions(value);
		}
		if (name === "studentId") {
			setStudentId(value);
		}
		if (name === "studentName") {
			setStudentName(value);
		}
		if (name === "studentCountry") {
			setStudentCountry(value);
		}

		// if (name === "getTermsURL") {
		// 	setGetTermsURL(value);
		// }
		if (name === "getRedirectTime") {
			setGetRedirectTime(value)
		}
		if (name === "getIsAutoRedirect") {
			setGetIsAutoRedirect(value)
		}
		if (name === "countrySelection") {
			setcountrySelection(value)
		}

		//Two factor authentication
		if (name === 'twofaSmsOtpAllowed') {
			settwofaSmsOtpAllowed(value);
		}
		if (name === 'twofaEmailOtpAllowed') {
			settwofaEmailOtpAllowed(value);
		}
		if (name === 'twofaConfigurationUser') {
			settwofaConfigurationUser(value);
		}
		if (name === 'twofaconfigurationGoogle') {
			settwofaconfigurationGoogle(value);
		} //changes made by rohit 18/6/2025


		//Consent (Sign up and Transaction)
		if (name === 'getSignUpConsent') {
			setGetSignUpConsent(value);
		}
		if (name === 'getTransactionConsent') {
			setGetTransactionConsent(value);
		}
		if (name === 'getKycRequired') {
			setGetKycRequired(value);
		}

		if(name==='settlement'){
			setSettlement(value);
		}
		if(name==='refundmodule'){
			setRefundmodule(value);
		}
		if(name==='refundmodule'){
			setSummaryReportModule(value);
		}

	};

	const editConfigurationListApi = () => {
		setUpdateConfigurationStatus(true);
		if (role == "") {
			setNotificationOpen(true);
		} else {
			const editConfigurationListApiReqs = {
				actionCustomerMasterRequestVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId || "",
					role: role
				},
				settingsRequestVO: {
					action: ""
				},
				accountConfReqVO: {
					businessSignupAllowed: businessSignupAllowed == "Y" ? "1" : "0",
					changePasswordAllowed: changePasswordAllowed,
					dealerMAppingAllowed: dealerMappingRequired,
					directorCount: maxUboCount,
					isAutoFilled: autoFilledAllowed == "Y" ? "1" : "0",
					// isCustCreationAllowed: "N",
					isEmailAllowed: emailAllowed == "Y" ? "1" : "0",
					isMerchant: merchantRequired,
					isSMSAllowed: smsAllowed == "Y" ? "1" : "0",
					prefixAccountId: prefixAccountId,
					uboCount: maxUboCount,
					isNewDevice: newDeviceCheckAllowed,
					isCustCreationAllowed: isCustCreationAllowed,
					isSignUpBankRequired: addBankDuringSignUp,
					ifNationalityRequired: nationalityRequired,
					ifDOBrequired: dobRequired,
					isKycRequired: getKycRequired,
					twoFactorGoogle: twofaconfigurationGoogle //change made rohit 18/6/2025
				},
				marketPlaceConfReqVO: {
					walletOwnerId: regenerateTokenRes.data.partnerId || "",
					role: role,
					isDealsWant: dealRequired,
					isPromoCodeAllowed: isPromoCodeAllowed,
					orderMngtAllowed: orderMgtAllowed,
					orderSellRptAllowed: orderSellReportAllowed,
					productMngtAllowed: prdMgtAllowed
				},
				voucherConfigurationVO: {
					isRedeemExactOrderAmount: redeemExactOrderAmount,
					isSettelementRequired: settlementReportRequired,
					isapikey: aPIKeyRequired,
					myVouchersAllowed: myVoucherAllowed,
					redeemConfiguration:
						redeemAuthentication == "Select Redeem Authentication"
							? ""
							: redeemAuthentication,
					settingId: "2",
					voucherChangePasswordAllowed: "N",
					voucherPurchaseAllowed: voucherPurchaseAllowed,
					voucherTransPasswordAllowed: redeemPasswordAllowed,
					voucherTransactionHistoryAllowed: transactionHistoryAllowedv,

				},
				walletConfReqVO: {
					cashoutPinAllowed: cashoutSecurityAllowed,
					integrationType: integration,
					isActivityLogAllowed: activityLogAllowed,
					isBillPayment: billPaymentAllowed,
					isBlockchainAllowed: blockChainAllowed,
					isCashOutAllowed: cashoutAllowed,
					isCashinAllowed: cashInAllowed,
					isCashinSecurityAllowed: requestCashInAllowed,
					isCheckDeposite: checkDepositAllowed,
					isDonation: donationAllowed,
					isLoadAmountPageAllowed: "Y",
					isLoadMoneyAllowed: loadMoneyAllowed,
					isLoadWithWalletAllowed: loadwithWalletAllowed,
					isLoyaltyPointsAllowed: loyaltyPointsAllowed,
					isMyBankAllowed: myBankAllowed,
					isMyCardAllowed: myCardAllowed,
					isMyWalletAllowed: walletAllowed,
					isPayAllowed: payAllowed,
					isPayReceived: payReceivedAllowed,
					isRadioAllowed: radioAllowed,
					isRechargeAllowed: rechargeAllowed,
					isRequestCashOutAllowed: requestCashOutAllowed,
					isRequestCashinAllowed: requestCashInAllowed,
					isRequestMoneyAllowed: requestMoneyAllowed,
					isSendMoneyAllowed: sendMoneyAllowed,
					isSendMoneyMerchant: sendMoneyMerchantRequired,
					isStoreRequired: storeRequired,
					isUserManagement: userManagement,
					isWalletTransferAllowed: walletTransferAllowed,
					isWithdrawMoneyAllowed: withdrawMoneyAllowed,
					isWithdrawalVerification: withdrawVerificationAllowed,
					loadPinAllowed: loadSecurityAllowed,
					payOption: payOption == "Select Pay Option" ? "" : payOption,
					payOrderPinAllowed: payOrderSecurityAllowed,
					payPinAllowed: paySecurityAllowed,
					profileSettingAllowed: profSettAlloweds,
					purchasePinAllowed: purchaseSecurityAllowed,
					requestPinAllowed: requestSecurityAllowed,
					role: role,
					sendPinAllowed: sendSecurityAllowed,
					transactionHistAllowed: transactionHistAllowed,
					walletHistAllowed: walletHistoryAllowed,
					withdrawPinAllowed: withdrawSecurityAllowed,
					isSendToContactAllowed: sendToContactAllowed,
					isSendToSelfAllowed: sendToSelfAllowed,
					isSendToOtherAllowed: sendToOtherAllowed,
					isCheckBalanceAllowed: checkBalanceAllowed,
					isManageBeneficiariesAllowed: manageBeneficiariesAllowed,
					isMyIBANAllowed: myIbanAllowed,
					isSEPAAllowed: isSEPAAllowed,
					isRefund: getRefund,
					isPartialRefund: getPartialRefund,
					isFullRefund: getFullRefund,
					isTermsAndConditions: getIsTermsAndConditions,
					studentId: studentId,
					studentName: studentName,
					studentCountry: studentCountry,
					// termsUrl: getTermsURL,
					twoFactorSMS: twofaSmsOtpAllowed,
					twoFactorEmail: twofaEmailOtpAllowed,
					twoFactorByUser: twofaConfigurationUser,
					signupConsent: getSignUpConsent,
					transactionConsent: getTransactionConsent,
					isAutoRedirect: getIsAutoRedirect,
					redirectTime: getRedirectTime,
					isCountrySelection: countrySelection,
					isSettlementAllowed:settlement,
					isRefundAllowed:refundmodule,
					isSummaryReportAllowed:summaryreportmodule,
				},
				preparedCardRqeVO: {
					allowCustomerToActivateCard: customerActivateCardRequired,
					isPrepaidCardFeatureRequired: prepaidCardFeatureRequired,
					prepaidCard: applyingPrepaidCardDuringSignUp
				}
			};
			dispatch(getUpdateConfigurationList(editConfigurationListApiReqs, authToken));
		}
	};

	const updateConfigurationFunc = () => {
		if (updateConfigurationStatus) {
			// if (updateConfigurationListRes.data.status) {
			if (updateConfigurationListRes.success) {
				setUpdateConfigurationArray(updateConfigurationListRes.data);
				setNotificationOpen(true);
			}
			if (updateConfigurationListRes.failed) {
				setUpdateConfigurationArray(updateConfigurationListRes.data);
				setNotificationOpen(true);
				if (
					updateConfigurationListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateConfigurationListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			// if (updateConfigurationListRes.data.status == "Not Found") {
			//   setUpdateConfigurationArray(updateConfigurationListRes.data);
			//   setNotificationOpen(true);
			// }
			// }
		}
	};

	useEffect(() => {
		// if (updateConfigurationListRes.success) {
		updateConfigurationFunc();
		// }
	}, [updateConfigurationListRes]);
	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Role"
								fullWidth
								variant="standard"
								type="text"
								name="role"
								defaultValue={role || "Select Role"}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Select Role" selected="Select Role">
									Select Role
								</MenuItem>
								{getWalletRolesRes.success &&
									getWalletRolesRes.data.rolesList.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>
						</Grid>
					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1"
									className="tableHeaderTextColor"
								> Market Place </Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								autoFocus
								margin="dense"
								label="Deals Required"
								fullWidth
								name="dealRequired"
								variant="standard"
								type="text"
								value={dealRequired || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>

								{/* <MenuItem value={dealRequired} selected={dealRequired}>
                  {dealRequired}
                </MenuItem> */}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								autoFocus
								margin="dense"
								label="Order Management Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="orderMgtAllowed"
								value={orderMgtAllowed}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								id="name"
								label="
                Product Management Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="prdMgtAllowed"
								value={prdMgtAllowed}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								label="Order Sell Report Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="orderSellReportAllowed"
								value={orderSellReportAllowed}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								id="name"
								label="Promo Code Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="isPromoCodeAllowed"
								value={isPromoCodeAllowed}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor"> Sign Up </Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								label="Merchant Required"
								fullWidth
								variant="standard"
								type="text"
								name="merchantRequired"
								value={merchantRequired || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>


						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Dealer Mapping Required"
								fullWidth
								variant="standard"
								type="text"
								name="dealerMappingRequired"
								value={dealerMappingRequired || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								//autoFocus
								margin="dense"
								label="Prefix Account Id"
								fullWidth
								type="text"
								name="prefixAccountId"
								id="prefixAccountId"
								//{...params}
								value={prefixAccountId || ""}
								onChange={handleChange}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}

							/>
						</Grid>

						{/* changes */}

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								label="Email Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="emailAllowed"
								value={emailAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="1">Y</MenuItem>
								<MenuItem value="0">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="SMS Allowed"
								fullWidth
								variant="standard"
								name="smsAllowed"
								value={smsAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="1">Y</MenuItem>
								<MenuItem value="0">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="
                Business Signup Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="businessSignupAllowed"
								value={businessSignupAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="1">Y</MenuItem>
								<MenuItem value="0">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								label="Max UBO Count"
								fullWidth
								variant="standard"
								type="text"
								name="maxUboCount"
								value={maxUboCount || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="0">0</MenuItem>
								<MenuItem value="1">1</MenuItem>
								<MenuItem value="2">2</MenuItem>

								<MenuItem value="3">3</MenuItem>
								<MenuItem value="4">4</MenuItem>
								<MenuItem value="5">5</MenuItem>

								<MenuItem value="6">6</MenuItem>
								<MenuItem value="7">7</MenuItem>
								<MenuItem value="8">8</MenuItem>

								<MenuItem value="9">9</MenuItem>
								<MenuItem value="10">10</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Max Director Count"
								fullWidth
								variant="standard"
								type="text"
								name="maxDirectorCount"
								value={maxDirectorCount || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="0">0</MenuItem>
								<MenuItem value="1">1</MenuItem>
								<MenuItem value="2">2</MenuItem>

								<MenuItem value="3">3</MenuItem>
								<MenuItem value="4">4</MenuItem>
								<MenuItem value="5">5</MenuItem>

								<MenuItem value="6">6</MenuItem>
								<MenuItem value="7">7</MenuItem>
								<MenuItem value="8">8</MenuItem>

								<MenuItem value="9">9</MenuItem>
								<MenuItem value="10">10</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="AutoFilled Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="autoFilledAllowed"
								value={autoFilledAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="1">Y</MenuItem>
								<MenuItem value="0">N</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								id="name"
								label="Add Bank During SignUp"
								fullWidth
								variant="standard"
								type="text"
								name="addBankDuringSignUp"
								value={addBankDuringSignUp || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Nationality Required"
								fullWidth
								variant="standard"
								type="text"
								name="nationalityRequired"
								value={nationalityRequired || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="DOB Required"
								fullWidth
								variant="standard"
								type="text"
								name="ifDOBrequired"
								value={dobRequired || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="KYC Required"
								fullWidth
								variant="standard"
								type="text"
								name="getKycRequired"
								value={getKycRequired || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={8}>
							<Box style={{ marginTop: "10px" }}>
								<Typography>Sign Up Consent</Typography>
								<textarea id="w3review" rows="5" className="textAreaField" style={{ minWidth: "66%" }}
									name="getSignUpConsent"
									value={getSignUpConsent || ""}
									onChange={handleChange}
								>
								</textarea>
							</Box>

						</Grid>


					</Grid>

					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor">
									{" "}
									Two Factor Authentication{" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="SMS OTP During Login Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="twofaSmsOtpAllowed"
								value={twofaSmsOtpAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Email OTP During Login Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="twofaEmailOtpAllowed"
								value={twofaEmailOtpAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="2FA Configuration By User"
								fullWidth
								variant="standard"
								type="text"
								name="twofaConfigurationUser"
								value={twofaConfigurationUser || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="2FA Google Authenticator"
								fullWidth
								variant="standard"
								type="text"
								name="twofaconfigurationGoogle"
								value={twofaconfigurationGoogle || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor"> Login</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="New Device Check Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="newDeviceCheckAllowed"
								value={newDeviceCheckAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="
                Change Password Allowed"
								fullWidth
								variant="standard"
								name="changePasswordAllowed"
								value={changePasswordAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Customer Creation Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="isCustCreationAllowed"
								value={isCustCreationAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
								<MenuItem value="D">D</MenuItem>
							</TextField>
						</Grid>

					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor"> Prepaid Card </Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Customer Activate Card Required"
								fullWidth
								variant="standard"
								value={customerActivateCardRequired || ""}
								name="customerActivateCardRequired"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Prepaid Card Feature Required"
								fullWidth
								variant="standard"
								value={prepaidCardFeatureRequired || ""}
								name="prepaidCardFeatureRequired"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="
                Applying Prepaid Card During SignUp"
								fullWidth
								value={applyingPrepaidCardDuringSignUp || ""}
								name="applyingPrepaidCardDuringSignUp"
								onChange={handleChange}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor"> Wallet Settings </Typography>
							</Alert>
						</Grid>


						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="
                Activity Log Allowed"
								fullWidth
								variant="standard"
								type="text"
								value={activityLogAllowed || ""}
								name="activityLogAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="
                Wallet Transfer Allowed"
								fullWidth
								value={walletTransferAllowed || ""}
								name="walletTransferAllowed"
								onChange={handleChange}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"
								label="
                Loyalty Points Allowed"
								fullWidth
								variant="standard"
								value={walletHistoryAllowed || ""}
								name="walletHistoryAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								label="
                Wallet History Allowed"
								fullWidth
								type="text"
								name="loyaltyPointsAllowed"
								value={loyaltyPointsAllowed || ""}
								onChange={handleChange}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								id="name"
								label="
                Integration"
								fullWidth
								variant="standard"
								type="text"
								value={integration || ""}
								name="integration"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="api">API</MenuItem>
								<MenuItem value="checkout">checkout</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								id="name"
								label="Transaction History Allowed  "
								fullWidth
								variant="standard"
								value={transactionHistAllowed || ""}
								name="transactionHistAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
								<MenuItem value="D">D</MenuItem>
							</TextField>
						</Grid>


					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor">
									{" "}
									Load Configuration{" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="Load Money Allowed"
								fullWidth
								variant="standard"
								name="loadMoneyAllowed"
								value={loadMoneyAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}

							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Load With Wallet Allowed"
								fullWidth
								variant="standard"
								value={loadwithWalletAllowed || ""}
								name="loadwithWalletAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								// autoFocus
								label="
                Load Security Allowed"
								fullWidth
								value={loadSecurityAllowed || ""}
								name="loadSecurityAllowed"
								variant="standard"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor">
									{" "}
									Withdraw Configuration{" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="Withdraw Money Allowed"
								fullWidth
								variant="standard"
								type="text"
								value={withdrawMoneyAllowed || ""}
								name="withdrawMoneyAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="
                Withdraw Verification Allowed"
								fullWidth
								name="withdrawVerificationAllowed"
								value={withdrawVerificationAllowed || ""}
								onChange={handleChange}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="
                Withdraw Security Allowed"
								fullWidth
								value={withdrawSecurityAllowed || ""}
								name="withdrawSecurityAllowed"
								onChange={handleChange}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>


					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor">
									{" "}
									Send Configuration{" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="
									Send Money Allowed"
								fullWidth
								variant="standard"
								value={sendMoneyAllowed || ""}
								name="sendMoneyAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>


						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="
                Send Money Merchant Required"
								fullWidth
								name="sendMoneyMerchantRequired"
								value={sendMoneyMerchantRequired || ""}
								onChange={handleChange}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								// autoFocus
								label="
                Send Security Allowed"
								fullWidth
								variant="standard"
								name="sendSecurityAllowed"
								onChange={handleChange}
								value={sendSecurityAllowed}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"
								variant="standard"
								label="
                Request Security Allowed"
								fullWidth
								value={requestSecurityAllowed || ""}
								name="requestSecurityAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="
                Request Money Allowed"
								fullWidth
								variant="standard"
								type="text"
								value={requestMoneyAllowed || ""}
								name="requestMoneyAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>






					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor">
									{" "}
									Pay Configuration{" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="
                Pay Allowed"
								fullWidth
								variant="standard"
								value={payAllowed || ""}
								name="payAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="
                Pay Option"
								fullWidth
								variant="standard"
								defaultValue={"Select Pay Option" || payOption}
								// value={payOption || ""}
								name="payOption"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem
									value="Select Pay Option"
									selected="Select Pay Option"
								>
									Select Pay Option
								</MenuItem>
								<MenuItem value="Load">Other Option</MenuItem>
								<MenuItem value="Wallet">Wallet</MenuItem>
								<MenuItem value="Wallet Load Auto">Wallet Load Auto</MenuItem>
								<MenuItem value="Wallet Load Manual">
									Wallet Load Manual
								</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								label="
                Pay Security Allowed"
								fullWidth
								variant="standard"
								value={paySecurityAllowed || ""}
								name="paySecurityAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								label="
                Purchase Security Allowed"
								fullWidth
								value={purchaseSecurityAllowed || ""}
								name="purchaseSecurityAllowed"
								onChange={handleChange}
								variant="standard"
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>





					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor">
									{" "}
									Profile Configuration{" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								label="
                My Card Allowed"
								fullWidth
								variant="standard"
								value={myCardAllowed || ""}
								name="myCardAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								// autoFocus
								label="
                My Bank Allowed"
								fullWidth
								variant="standard"
								value={myBankAllowed || ""}
								name="myBankAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								label="
                Wallet Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="walletAllowed"
								value={walletAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"
								variant="standard"
								// autoFocus
								label="
                User Management "
								fullWidth
								value={userManagement || ""}
								name="userManagement"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								id="name"
								label="Store Required  "
								fullWidth
								variant="standard"
								value={storeRequired || ""}
								name="storeRequired"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="My IBAN Allowed"
								fullWidth
								variant="standard"
								value={myIbanAllowed || ""}
								name="myIbanAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
								<MenuItem value="D">D</MenuItem>
							</TextField>
						</Grid>


						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Profile Setting Allowed"
								fullWidth
								variant="standard"
								value={profSettAlloweds || ""}
								name="profSettAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
								<MenuItem value="D">D</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="SEPA Allowed"
								fullWidth
								variant="standard"
								value={isSEPAAllowed || ""}
								name="isSEPAAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
								<MenuItem value="D">D</MenuItem>
							</TextField>
						</Grid>






					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor">
									{" "}
									Pay Order Configuration{" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								variant="standard"
								// autoFocus
								margin="dense"
								label="
                Pay Order Allowed"
								fullWidth
								name="payOrderAllowed"
								value={payOrderAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="
                Pay Received Allowed"
								fullWidth
								variant="standard"
								name="payReceivedAllowed"
								value={payReceivedAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								// autoFocus
								label="
                Pay Order Security Allowed"
								value={payOrderSecurityAllowed || ""}
								name="payOrderSecurityAllowed"
								fullWidth
								variant="standard"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>






					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor">
									{" "}
									Other Configuration{" "}
								</Typography>
							</Alert>
						</Grid>


						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="
                Request CashOut Allowed"
								fullWidth
								variant="standard"
								name="requestCashOutAllowed"
								value={requestCashOutAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="
                CashOut Allowed"
								fullWidth
								variant="standard"
								name="cashoutAllowed"
								value={cashoutAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="
                Check Deposit Allowed"
								fullWidth
								variant="standard"
								name="checkDepositAllowed"
								value={checkDepositAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"
								variant="standard"

								// autoFocus
								label="
                 CashIn Allowed"
								fullWidth
								name="cashInAllowed"
								value={cashInAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"
								variant="standard"

								// autoFocus
								label="
                Request CashIn Allowed"
								fullWidth
								name="requestCashInAllowed"
								value={requestCashInAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
								{/* <MenuItem
                  value={requestCashInAllowed}
                  selected={requestCashInAllowed}
                >
                  {requestCashInAllowed}
                </MenuItem> */}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="
                Request CashOut Allowed"
								fullWidth
								variant="standard"
								type="text"
								name="requestCashOutAllowed"
								value={requestCashOutAllowed || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"
								variant="standard"

								label="
                Radio Allowed"
								fullWidth
								value={radioAllowed || ""}
								name="radioAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								label="
                Block Chain Allowed"
								fullWidth
								variant="standard"
								value={blockChainAllowed || ""}
								name="blockChainAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								label="
                Recharge Allowed"
								fullWidth
								variant="standard"
								value={rechargeAllowed || ""}
								name="rechargeAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								// autoFocus
								label="
                Bill Payment Allowed"
								fullWidth
								variant="standard"
								value={billPaymentAllowed || ""}
								name="billPaymentAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>


						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								label="
                CashOut Security Allowed"
								fullWidth
								variant="standard"
								value={cashoutSecurityAllowed || ""}
								name="cashoutSecurityAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								label="
                CashIn Security Allowed"
								fullWidth
								variant="standard"
								value={cashinSecurityAllowed || ""}
								name="cashinSecurityAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"

								label="
								Donation Allowed"
								fullWidth
								variant="standard"
								value={donationAllowed || ""}
								name="donationAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid>
								<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Settlment module allow"
								fullWidth
								variant="standard"
								type="text"
								name="settlement"
								value={settlement || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
								<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Refund module allow"
								fullWidth
								variant="standard"
								type="text"
								name="refundmodule"
								value={refundmodule || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

							<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Summary Report module allow"
								fullWidth
								variant="standard"
								type="text"
								name="refundmodule"
								value={summaryreportmodule || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>



						{/* <Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								autoFocus
								margin="dense"
								id="name"
								label="
                Donation Allowed"
								fullWidth
								variant="standard"
								name="donationAllowed"
								value={donationAllowed || ""}
								onChange={handleChange}
							>
								<MenuItem value="Y">Y (Allow)</MenuItem>
								<MenuItem value="N">N (Not Allow)</MenuItem>
								<MenuItem value="D">D (Display and Allow)</MenuItem>
							</TextField>
						</Grid> */}







					</Grid>

					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor"> Voucher Configuration </Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="Voucher Purchase Allowed"
								fullWidth
								variant="standard"
								name="voucherPurchaseAllowed"
								onChange={handleChange}
								value={voucherPurchaseAllowed || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem
                  value={voucherPurchaseAllowed}
                  selected={voucherPurchaseAllowed}
                >
                  {voucherPurchaseAllowed}
                </MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="Transaction History Allowed"
								fullWidth
								variant="standard"
								value={transactionHistoryAllowedv || ""}
								name="transactionHistoryAllowedv"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem
                  value={transactionHistoryAllowedv}
                  selected={transactionHistoryAllowedv}
                >
                  {transactionHistoryAllowedv}
                </MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="
                My Voucher Allowed"
								fullWidth
								variant="standard"
								value={myVoucherAllowed || ""}
								name="myVoucherAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem value={myVoucherAllowed} selected={myVoucherAllowed}>
                  {myVoucherAllowed}
                </MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								label="Redeem Password Allowed"
								fullWidth
								variant="standard"
								value={redeemPasswordAllowed || ""}
								name="redeemPasswordAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem
                  value={redeemPasswordAllowed}
                  selected={redeemPasswordAllowed}
                >
                  {redeemPasswordAllowed}
                </MenuItem>{" "} */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// required
								// autoFocus
								margin="dense"
								id="name"
								label="Redeem Authentication"
								fullWidth
								variant="standard"
								type="text"
								// value={redeemAuthentication || ""}
								defaultValue={
									"Select Redeem Authentication" || redeemAuthentication
								}
								name="redeemAuthentication"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem
									value="Select Redeem Authentication"
									selected="Select Redeem Authentication"
								>
									Select Redeem Authentication
								</MenuItem>
								<MenuItem value="customerEmail">CustomerEmail</MenuItem>
								<MenuItem value="customerEmail,customerPassword">
									Customer Email & Password
								</MenuItem>
								<MenuItem value="customerEmail,transactionPassword">
									Customer Email & Redeem Password
								</MenuItem>
								customerEmail,transactionPassword
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="Redeem Exact Order Amount"
								fullWidth
								variant="standard"
								value={redeemExactOrderAmount || ""}
								name="redeemExactOrderAmount"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem
                  value={redeemExactOrderAmount}
                  selected={redeemExactOrderAmount}
                >
                  {redeemExactOrderAmount}
                </MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="Settlement Report Required"
								fullWidth
								variant="standard"
								// defaultValue={"Select Order Sell Report Allowed" || role}
								name="settlementReportRequired"
								value={settlementReportRequired || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem
                  value={settlementReportRequired}
                  selected={settlementReportRequired}
                >
                  {settlementReportRequired}
                </MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								// autoFocus
								margin="dense"
								id="name"
								label="API Key Required"
								fullWidth
								variant="standard"
								type="text"
								name="aPIKeyRequired"
								// defaultValue={"Select Order Sell Report Allowed" || role}
								value={aPIKeyRequired || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem value={aPIKeyRequired} selected={aPIKeyRequired}>
                  {aPIKeyRequired}
                </MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor">
									{" "}
									Bank Configuration{" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Send To Contact Allowed"
								fullWidth
								variant="standard"
								name="sendToContactAllowed"
								onChange={handleChange}
								value={sendToContactAllowed || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="D">D</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Send To Self Allowed"
								fullWidth
								variant="standard"
								value={sendToSelfAllowed || ""}
								name="sendToSelfAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="D">D</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Send To Other Allowed"
								fullWidth
								variant="standard"
								value={sendToOtherAllowed || ""}
								name="sendToOtherAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="D">D</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"
								label="Check Balance Allowed"
								fullWidth
								variant="standard"
								value={checkBalanceAllowed || ""}
								name="checkBalanceAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="D">D</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={6} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Manage Beneficiaries Allowed"
								fullWidth
								variant="standard"
								value={manageBeneficiariesAllowed || ""}
								name="manageBeneficiariesAllowed"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="D">D</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor">
									{" "}
									Refund Configuration{" "}
								</Typography>
							</Alert>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Refund"
								fullWidth
								variant="standard"
								name="getRefund"
								onChange={handleChange}
								value={getRefund || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="D">D</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Partial Refund"
								fullWidth
								variant="standard"
								name="getPartialRefund"
								onChange={handleChange}
								value={getPartialRefund || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="D">D</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Full Refund"
								fullWidth
								variant="standard"
								name="getFullRefund"
								onChange={handleChange}
								value={getFullRefund || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								<MenuItem value="D">D</MenuItem>
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

					</Grid>
					<Grid container spacing={2} style={{ padding: "25px" }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="text-center tableHeaderColor"
								variant="secondary"
								fullWidth={true}
							>
								<Typography variant="body1" className="tableHeaderTextColor">
									{" "}
									Checkout Configuration{" "}
								</Typography>
							</Alert>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Is Country Selection"
								fullWidth
								variant="standard"
								name="countrySelection"
								onChange={handleChange}
								value={countrySelection || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem value="D">D</MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Is Terms And Conditions"
								fullWidth
								variant="standard"
								name="getIsTermsAndConditions"
								onChange={handleChange}
								value={getIsTermsAndConditions || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem value="D">D</MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						{/* <Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								disabled={getIsTermsAndConditions === "N" ? true : false}
								margin="dense"
								id="name"
								label="Terms URL"
								fullWidth
								variant="standard"
								type="text"
								name="getTermsURL"
								value={getTermsURL}
								onChange={handleChange}
							/>
						</Grid> */}
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label=" Is Auto Redirect"
								fullWidth
								variant="standard"
								name="getIsAutoRedirect"
								onChange={handleChange}
								value={getIsAutoRedirect || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem value="D">D</MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								autoFocus
								disabled={getIsTermsAndConditions === "N" ? true : false}
								margin="dense"
								id="name"
								label="Redirect Time"
								placeholder="Enter Time In Millisecond"
								fullWidth
								variant="standard"
								type="text"
								name="getRedirectTime"
								value={getRedirectTime}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Student ID"
								fullWidth
								variant="standard"
								name="studentId"
								onChange={handleChange}
								value={studentId || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem value="D">D</MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Student Name"
								fullWidth
								variant="standard"
								name="studentName"
								onChange={handleChange}
								value={studentName || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem value="D">D</MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								select
								margin="dense"
								id="name"
								label="Student Country"
								fullWidth
								variant="standard"
								name="studentCountry"
								onChange={handleChange}
								value={studentCountry || ""}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							>
								{/* <MenuItem value="D">D</MenuItem> */}
								<MenuItem value="Y">Y</MenuItem>
								<MenuItem value="N">N</MenuItem>
							</TextField>
						</Grid>
						<Grid item xs={12}>
							<Box style={{ marginTop: "10px" }}>
								<Typography>Consent</Typography>
								<textarea id="w3review" rows="5" className="textAreaField" style={{ minWidth: '66%' }}
									type="text"
									name="getTransactionConsent"
									value={getTransactionConsent || ""}
									onChange={handleChange}
								>

								</textarea>
							</Box>
						</Grid>

					</Grid>
					<Grid
						item
						xs={12}
						sm={12}
						md={12}
						lg={12}
						style={{ marginLeft: "auto", marginRight: "auto" }}
					>
						{/* <Button
              className="text-center"
              variant="secondary"
              style={{
                backgroundColor: "#00b9f5",
                color: "white",
              }}
              onClick={editConfigurationListApi}
            >
              Save
            </Button> */}
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={editConfigurationListApi}
						>
							Save
						</CustomButton>
					</Grid>
				</Card>
			</Layout>

			{notificationOpen == true && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								Please Select Role
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateConfigurationListRes.success && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateConfigurationListRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateConfigurationListRes.failed && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateConfigurationListRes.data.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{/* {updateConfigurationArray.status == "Not Found" && (
        <div>
          <Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={failed} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {updateConfigurationArray.description}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )} */}
		</>
	);
};

export default AddNewConfigration;
